import api from './api';

/**
 * Global unified search — searches patients by name, MRN, phone, or email.
 * Auto-detects query type on the backend.
 * @param {string} query - Search term (min 2 chars)
 * @param {number} limit - Max results (default 10)
 */
export const globalSearch = async (query, limit = 10) => {
  const response = await api.get('/api/v1/search', {
    params: { q: query, limit },
  });
  return response.data;
};
